<template>
  <div class="content">
    <div class="build-CURD">
      <div class="build-title">
        <img src="../../assets/image/back.png" alt @click="$router.go(-1)" />
        <span>{{this.$route.params.name}}人员统计</span>
        <!-- <span>班组人员统计</span> -->
      </div>
      <div class="build-bar">
        <span>班组人数</span>
        <span style="top:3px;color:#17B2FE">{{attendCount.person}}人</span>
        <span style="margin-left:30px;">累计出勤</span>
        <span style="top:3px;color:#17B2FE">{{attendCount.sum}}人</span>
        <span style="margin-left:30px;">当月出勤</span>
        <span style="margin-right:20px !important;top:3px;color:#17B2FE">{{attendCount.num}}人</span>
        <!-- <span>角色名：</span> -->
        <!-- <el-input placeholder="请输入您的角色名" v-model="tableDataName"></el-input> -->
        <el-date-picker
          type="month"
          value-format="yyyy-MM"
          placeholder="选择日期"
          v-model="searchDate"
          @change="doFilter"
        ></el-date-picker>
        <!-- <el-button type="primary" icon="el-icon-search" @click="doFilter" style="margin-left:20px;">查询</el-button> -->
        <el-button type="primary" class="add-user" @click="addRow()" style="float:right;">导出</el-button>
      </div>
      <div class="build-table">
        <el-table
          :default-sort="{prop: 'date', order: 'descending'}"
          :data="tableList"
          border
          height="100%"
          style="width:2470px;margin-top:8px;"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <a>{{ scope.row.personName}}</a>
            </template>
          </el-table-column>
          <el-table-column label="工种">
            <template slot-scope="scope">
              <span>{{ scope.row.workTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="累计出勤">
            <template slot-scope="scope">
              <span>{{ scope.row.sum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当月出勤">
            <template slot-scope="scope">
              <span>{{ scope.row.num}}</span>
            </template>
          </el-table-column>
          <el-table-column label="信息上传状态">
            <template slot-scope="scope">
              <div v-if="scope.row.detuoStatus==0">未上传</div>
              <div v-if="scope.row.detuoStatus==1">
                <div style="color:red">上传临时库失败</div>
                <el-tooltip placement="bottom">
                  <div slot="content">原因:{{scope.row.detuoReason}}</div>
                  <div class="font-head" style="width:10%">原因:{{scope.row.detuoReason}}</div>
                </el-tooltip>
                <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.detuoDate}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.detuoDate}}</div>
                </el-tooltip>
              </div>
              <div v-if="scope.row.detuoStatus==2">
                <div style="color:#67C23A">上传临时库成功</div>
              </div>
              <div v-if="scope.row.detuoStatus==3">
                <div style="color:red">上传正式库失败</div>
                <el-tooltip placement="bottom">
                  <div slot="content">原因:{{scope.row.detuoReason}}</div>
                  <div class="font-head" style="width:10%">原因:{{scope.row.detuoReason}}</div>
                </el-tooltip>
                <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.detuoDate}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.detuoDate}}</div>
                </el-tooltip>
              </div>
              <div v-if="scope.row.detuoStatus==4">
                <div style="color:#67C23A">上传正式库成功</div>
                <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.detuoDate}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.detuoDate}}</div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="照片上传状态">
            <template slot-scope="scope">
              <div v-if="scope.row.detuoStatus2==0">未上传</div>
              <div v-if="scope.row.detuoStatus2==1">
                <div style="color:red">上传临时库失败</div>
                <el-tooltip placement="bottom">
                  <div slot="content">原因:{{scope.row.detuoReason2}}</div>
                  <div class="font-head" style="width:10%">原因:{{scope.row.detuoReason2}}</div>
                </el-tooltip>
                <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.detuoDate2}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.detuoDate2}}</div>
                </el-tooltip>
              </div>
              <div v-if="scope.row.detuoStatus2==2">
                <div style="color:#67C23A">上传临时库成功</div>
              </div>
              <div v-if="scope.row.detuoStatus2==3">
                <div style="color:red">上传正式库失败</div>
                <el-tooltip placement="bottom">
                  <div slot="content">原因:{{scope.row.detuoReason2}}</div>
                  <div class="font-head" style="width:10%">原因:{{scope.row.detuoReason2}}</div>
                </el-tooltip>
                <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.detuoDate2}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.detuoDate2}}</div>
                </el-tooltip>
              </div>
              <div v-if="scope.row.detuoStatus2==4">
                <div style="color:#67C23A">上传正式库成功</div>
                <el-tooltip placement="bottom">
                  <div slot="content">时间:{{scope.row.detuoDate2}}</div>
                  <div class="font-head" style="width:10%">时间:{{scope.row.detuoDate2}}</div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="查看出勤">
            <template slot-scope="scope">
              <el-button size="mini" @click="attendInfo(scope.row)" style="color:#4D7BF4">查看</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="attendInfo(scope.row)" style="color:##4D7BF4">查看</el-button>
            </template>
          </el-table-column>-->
          <!-- <template slot="empty">加载中</template> -->
        </el-table>
        <!-- 分页展示 -->
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10,20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>-->
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
  data() {
    return {
      searchDate: util.myTime.getCurMonth(), //所选下拉框数据
      teamsId: '',
      currentPage: 1,
      pageSize: 10,
      pageInfo: {},
      tableList: [],
      totalItems: 0,
      projectId: '',
      attendCount: '',
      id: '',
      dataText: '数据加载中...'
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.projectId = this.$route.params.projectId
    // console.log(this.$route.params.id)
    this.getPersonList(), this.getPerson()
  },
  methods: {
    //监听时间
    doFilter() {
      this.getPerson()
      this.getPersonList()
    },
    // 班组人员信息统计
    getPerson() {
      let that = this
      myHttp
        .getLaborStatisByteamsPersonId({
          teamsId: this.id,
          projectId: this.projectId,
          date: this.searchDate
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var attendCount = []
              that.attendCount = resp.data.data.attendCount
              // console.log(resp.data.data.attendCount);
            } else {
              that.$message.error(resp.msg)
            }
          },
          function() {}
        )
    },

    // 班组人员统计信息列表
    getPersonList() {
      let that = this
      myHttp
        .getPersonPageList({
          teamsId: this.id,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          projectId: this.projectId,
          date: this.searchDate
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo.list || []
              that.tableList = list
              that.totalItems = resp.data.data.pageInfo.total || 0
              if (that.tableList.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.dataText = '暂无数据'
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    // 班组信息人员列表导出
    addRow() {
      var year = this.searchDate.split('-')[0]
      var month = this.searchDate.split('-')[1]
      var token = this.$store.state.token
      window.open(
        myHttp.exportTeamsPreson +
          '?teamsId=' +
          this.id +
          '&projectId=' +
          this.projectId +
          '&year1=' +
          year +
          '&month1=' +
          month +
          '&accessToken=' +
          token
      )
    },
    attendInfo(row) {
      this.$router.push({ name: 'workerInfo', params: { id: row.personId } })
    }
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage()
    // },
    // // 监控当前页码
    // currentChangePage(list) {
    //   this.getData()
    // }
  }
}
</script>
<style scoped>
.build-bar span {
  margin-left: 10px;
  font-size: 18px;
  position: relative;
  /* margin-right: 40px */
}
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table {
  height: calc(100% - 190px);
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar {
  padding: 10px 20px;
  text-align: left;
}
.build-title {
  height: 60px;
  box-shadow: 0 0 0 0 #ddd;
  border-bottom: 5px solid #ecf0f5;
  display: flex;
  align-items: center;
  align-content: center;
  padding: 0 20px;
}
.build-title img {
  cursor: pointer;
  margin-right: 10px;
}
</style>
